import React, { FunctionComponent, memo } from "react";
import { Flex, Text } from "@chakra-ui/react";


interface IProps{
  name: string;
  unit: string;
}


const SourceNameAndUnit: FunctionComponent<IProps> = memo(function SourceName({
  name,
  unit,
}) {
  return <>
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      alignItems="baseline"
    >
      <Text
        textTransform="uppercase"
        fontSize="0.9rem"
        fontWeight="bold"
      >
        {name}
      </Text>
      <Text
        fontSize="1.4rem"
      >
        {unit}
      </Text>
      
    </Flex>
  </>
});

export default SourceNameAndUnit;
